import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setInput } from '../Redux/actions';
import './SearchSection.css';

class SearchSection extends React.Component {

  handleClick = (tag) => {
    this.props.setInput(tag)
  }

  render() {
    return (
      <div id="search">
        <Button className='buttonScroll' onClick={()=> this.handleClick('')}> Show All </Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('unemployment')}> Unemployment </Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('food')}> Food </Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('donate')}> Donate </Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('housing')}> Housing </Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('wellbeing')}> Wellbeing</Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('education')}> Education </Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('elderly')}> Elderly </Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('deals/free')}> Deals/Free </Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('gaming')}> Gaming </Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('good news')}> Good News </Button>
        <Button className='buttonScroll' onClick={() => this.handleClick('data')}> Data </Button>
      </div>
    )
  }
}

const dispatch = {
  setInput
}

export default connect(null, dispatch)(SearchSection);